import React, { useState } from "react";
import AxiosInstance from "../../utils/axiosInstance";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const UploadUsers = ({ show, onClose }) => {
    const [uploadData, setUploadData] = useState({ file: null });
    const [errors, setErrors] = useState({});
    const [showLoader, setShowLoader] = useState(false);
    const [downloadFilePath, setDownloadFilePath] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        const newErrors = {};
        const maxFileSize = 5 * 1024 * 1024; // 5MB
        const allowedExtensions = ["csv"];

        if (!uploadData.file) newErrors.file = "Please select a file.";
        else {
            const file = uploadData.file;
            const fileExtension = file.name.split(".").pop().toLowerCase();
            if (file.size === 0) newErrors.file = "This file is empty.";
            else if (file.size > maxFileSize) newErrors.file = "File must be 5MB or less.";
            else if (!allowedExtensions.includes(fileExtension)) newErrors.file = "Invalid file type. Only CSV allowed.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        try {
            setShowLoader(true);

            const formData = new FormData();
            formData.append("file", uploadData.file);

            const response = await AxiosInstance.post(
                `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_UPLOAD_USERS}`,
                formData
            );

            if (response?.data?.statusCode === 200) {
                toast.success("File uploaded successfully!");
                setErrors({});
                setUploadData({ file: null });

                // Cache-busting for download
                if (response.data.download_file) {
                    const timestamp = new Date().getTime();
                    setDownloadFilePath(response.data.download_file + `?t=${timestamp}`);
                } else {
                    setDownloadFilePath(null);
                }
            } else {
                toast.error(response?.data?.message || "File upload failed!");
                setDownloadFilePath(null);
            }
        } catch (error) {
            console.error("Error during submission:", error);
            toast.error(error?.response?.data?.message || "Error submitting file.");
            setDownloadFilePath(null);
        } finally {
            setShowLoader(false);
        }
    };

    if (!show) return null;

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Upload Users CSV</h5>
                        <button type="button" className="btn-close" onClick={onClose} disabled={showLoader} />
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">CSV File *</label>
                            <input
                                type="file"
                                accept=".csv"
                                className="form-control"
                                onChange={(e) => setUploadData({ file: e.target.files[0] })}
                            />
                            {errors.file && <div className="text-danger">{errors.file}</div>}
                        </div>

                        <div className="mb-3">
                            <a
                                href="https://dev.contractorcn.com/USER_UPLOAD_FILES/user_temp.csv"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View Demo
                            </a>
                        </div>

                        {downloadFilePath && (
                            <div className="mb-3">
                                <a
                                    href={downloadFilePath}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-success"
                                >
                                    Download Report
                                </a>
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose} disabled={showLoader}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center justify-content-center"
                            onClick={handleSubmit}
                            disabled={showLoader}
                            style={{ minWidth: "120px", height: "45px" }}
                        >
                            {showLoader ? (
                                <span className="d-flex align-items-center">
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    Uploading...
                                </span>
                            ) : (
                                "Upload"
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadUsers;
